module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-TW":{"down":"下載應用程式"},"zh-TW2":{"down":"下載應用程式"},"zh-MO":{"down":"下載應用程式"},"en":{"down":"DOWNLOAD"},"ja":{"down":"ダウンロード"},"ko":{"down":"APP 다운"}}')
  delete Component.options._Ctor
}
